module.exports = __webpack_public_path__ + "img/115.9c2be92e.svg";